import * as React from 'react';
import Badge from '@mui/material/Badge';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MailIcon from '@mui/icons-material/Mail';
import { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Badge": Badge, "@mui/material/FormControl": FormControl, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/FormLabel": FormLabel, "@mui/material/Radio": Radio, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Box": Box, "@mui/material/IconButton": IconButton, "@mui/icons-material/Mail": MailIcon, "@mui/internal-core-docs/HighlightedCode": { HighlightedCode } } } });
export default ClientProvider;
